export * from './CollectionBook';
export * from './Navigation';
export * from './Product';
export * from './Query';

export type OSType = 'ANDROID' | 'IOS' | 'MWEBANDROID' | 'MWEBIOS' | 'WEB';
export type DeviceType = 'web' | 'mobileWeb' | 'mobile';
